
      var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBank = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 35,
  height: 33,
  viewBox: "0 0 35 33"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.317 9.431h5.201c1.369.004 2.477 1.139 2.482 2.539v9.07c-.005 1.4-1.113 2.535-2.482 2.54h-15.01c-1.372-.001-2.482-1.138-2.482-2.541v-9.07c.004-1.399 1.113-2.534 2.481-2.538h7.072m-6.527 9.535h13.921m-3.026-5.537h3.026",
  stroke: "var(--theme-primary, #810ea9)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 1)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--theme-primary, #810ea9)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M1.685 3.621A2.883 2.883 0 0 1 4.559.747h.304A2.883 2.883 0 0 1 7.738 3.62v23.89"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--theme-primary, #810ea9)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M7.755 27.581V3.7a7.583 7.583 0 0 0-.122-1.267A2.315 2.315 0 0 0 5.514.747"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.685,
  cy: 6.279,
  r: 1,
  fill: "var(--theme-primary, #810ea9)",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--theme-primary, #810ea9)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M16.179 30.456h13.669a2.884 2.884 0 0 0 2.874-2.875H13.808a2.884 2.884 0 0 1-2.883 2.875h-.304a2.884 2.884 0 0 1-2.875-2.875M4.707.747H24.42a2.318 2.318 0 0 1 2.119 1.685c.08.417.12.842.122 1.267"
})))));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"35\" height=\"33\" viewBox=\"0 0 35 33\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <g>\r\n            <g>\r\n                <g stroke=\"var(--theme-primary, #810ea9)\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\">\r\n                    <g>\r\n                        <path d=\"M12.291.615h5.201c1.369.004 2.477 1.139 2.482 2.539v9.07c-.005 1.4-1.113 2.535-2.482 2.54H2.482C1.11 14.763 0 13.626 0 12.223v-9.07C.004 1.754 1.113.619 2.481.615h7.072M3.026 10.15L16.947 10.15M13.921 4.613L16.947 4.613\" transform=\"translate(-265 -391) translate(265 392) translate(13.026 7.816)\"/>\r\n                    </g>\r\n                </g>\r\n                <g transform=\"translate(-265 -391) translate(265 392)\">\r\n                    <path stroke=\"var(--theme-primary, #810ea9)\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M1.685 3.621C1.69 2.036 2.974.751 4.559.747h.304C6.45.752 7.733 2.036 7.738 3.62v23.89\"/>\r\n                    <path stroke=\"var(--theme-primary, #810ea9)\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M7.755 27.581V3.7c-.005-.425-.046-.849-.122-1.267C7.363 1.473 6.51.795 5.514.747\"/>\r\n                    <circle cx=\"1.685\" cy=\"6.279\" r=\"1\" fill=\"var(--theme-primary, #810ea9)\" fill-rule=\"nonzero\"/>\r\n                    <path stroke=\"var(--theme-primary, #810ea9)\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M16.179 30.456h13.669c1.585-.005 2.87-1.29 2.874-2.875H13.808c-.005 1.589-1.294 2.875-2.883 2.875h-.304c-1.586-.005-2.87-1.29-2.875-2.875M4.707.747H24.42c.995.048 1.848.726 2.119 1.685.08.417.12.842.122 1.267\"/>\r\n                </g>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/bank.ad1401177ba3a95a50ab697d647297be.svg"),
        {
          React: SvgBank,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      